/* unplugin-vue-components disabled */import script from "./AddPrizeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPrizeModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPrizeModal.vue?vue&type=style&index=0&id=a7d3b5a2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7d3b5a2"]])

export default __exports__